import * as React from "react";

import { createRoot } from "react-dom/client";

import App from "./App";
import ThemeProvider from "../../components/ThemeProvider/ThemeProvider";

/* global document, Office, module, require, HTMLElement */

const title = "Contoso Task Pane Add-in";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

const renderApp = (AppComponent: typeof App) => {
  root?.render(
    <ThemeProvider>
      <AppComponent title={title} />
    </ThemeProvider>
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  renderApp(App);
});

if ((module as any).hot) {
  (module as any).hot.accept(["./App"], () => {
    const NextApp = require("./App").default;
    renderApp(NextApp);
  });
}
